import profiles from '../data/profiles/profiles.json';
import available_personas from '../data/navigation/available_personas.json';

const calculateBirthDate = ({age, dateOfBirth}: {age: number, dateOfBirth: number}) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  birthDate.setFullYear(today.getFullYear() - age);

  return birthDate;
}

const getProfileById = (searchId: string) => {
  return profiles.data.find(({ id }) => id === searchId);
};

export const mapProfileIds = (dataArr: Array<any>) => {
  return dataArr.map((data: any) => {
    let profiles = [];
    if (Object.keys(data).includes('profileIds')) {
      profiles = data['profileIds'].map((profileId: string) =>
        getProfileById(profileId)
      );
    }

    return {
      ...data,
      profiles,
    };
  });
};

export const getAllProfiles = () => {
  return {
    data: profiles.data.map((profile) => Object.assign({}, profile, {
      personas: profile.personas?.filter((persona: any) => {
        const _persona = available_personas.data?.find((ap: any) => ap.key === persona.id);
        return !!_persona?.enabled;
      }),
      dateOfBirth: calculateBirthDate({
        age: profile.age,
        dateOfBirth: profile.dateOfBirth
      })
    }))
  };
};
